export default __webpack_public_path__ + "static/media/d13.e04f4409.png";